import {
  Scale, Dna, Sparkles, Heart, User, Pill, Activity, Leaf, Zap, Droplet,
  type LucideIcon,
} from 'lucide-react';

const ICON_MAP: Record<string, LucideIcon> = {
  scale: Scale,
  dna: Dna,
  sparkles: Sparkles,
  heart: Heart,
  user: User,
  pill: Pill,
  bandage: Activity,
  leaf: Leaf,
  bolt: Zap,
  droplet: Droplet,
};

export function CategoryIcon({ iconKey, className }: { iconKey?: string; className?: string }) {
  const Icon = (iconKey && ICON_MAP[iconKey]) || Pill;
  return <Icon className={className || 'w-full h-full'} strokeWidth={1.25} />;
}
